import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import TargetGroup from '../../../stores/TargetGroup'
import Geopolygon from '../../../stores/Geopolygon'
import Boundary from '../../../stores/Boundary'
import ColorMenu from './ColorMenu'
import SavedMarker from '../../../stores/SavedMarker'

const ColorPane = ({ selectionStore, uiStore }) => {
  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    const itemToEdit = selectionStore.colorEditItem
    if (itemToEdit instanceof TargetGroup || (itemToEdit && (itemToEdit.geopolygons !== undefined || itemToEdit.savedMarkers !== undefined))) {
      uiStore.changePolygonColorsInGroup(itemToEdit)
    } else if (itemToEdit instanceof Geopolygon) {
      uiStore.changePolygonColor(itemToEdit)
    } else if (itemToEdit instanceof Boundary || (itemToEdit && (itemToEdit.inner_id !== undefined || itemToEdit.isZipCode !== undefined))) {
      uiStore.changeBoundaryColor(itemToEdit)
    } else if (itemToEdit instanceof SavedMarker) {
      uiStore.changeMarkerColor(itemToEdit)
    }
    uiStore.hideClickTooltip()
  }

  const handleCloseClick = (e) => {
    if (e && e.stopPropagation) e.stopPropagation()
    selectionStore.unselectColorEdit()
    uiStore.hideClickTooltip()
  }

  const handleResetColor = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    selectionStore.resetToOriginalColor()
  }

  return (
    <div
      className='click-tooltip color-palette-tooltip'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <ColorMenu
        handleSubmit={handleSubmit}
        handleCloseClick={handleCloseClick}
        handleResetColor={handleResetColor}
        showRecentColors
        isColorPane
      />
    </div>
  )
}

export default withTranslation()(inject('selectionStore', 'dataStore', 'uiStore')(observer(ColorPane)))
